import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateCustomerForm from "../../forms/CreateOrUpdateCustomerForm";
import { CustomerResponseDto } from "../../shared/dtos/customer/CustomerResponseDto";

interface UpdateCustomerModalProps {
  open: boolean;
  onClose: () => void;
  customer: CustomerResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateCustomerModal: React.FC<UpdateCustomerModalProps> = ({
  open,
  onClose,
  customer,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${customer?.name}`}
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateCustomerForm
      isEditing={true}
      customer={customer}
      loading={loading}
      error={error}
    />
  </AppModal>
);
export default UpdateCustomerModal;
